export default "__VITE_ASSET__iqyPM2TT__"